import { useObservable } from "@/hooks/useObservable";
import { swStatus } from "@/lib/sw";

export function UpdateBanner() {
  const { updateAvailable } = useObservable(swStatus.state$, {
    updateAvailable: false,
  });

  if (!updateAvailable) return null;

  return (
    <div
      data-testid="update-banner"
      role="status"
      style={{
        position: "fixed",
        top: "calc(env(safe-area-inset-top, 0px) + 12px)",
        left: "50%",
        transform: "translateX(-50%)",
        background: "var(--forest)",
        color: "var(--surface)",
        border: "none",
        borderRadius: "var(--r-md)",
        padding: "10px 14px",
        fontSize: 14,
        fontWeight: 600,
        boxShadow: "var(--shadow-md)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      <span>Ny versjon tilgjengelig</span>
      <button
        type="button"
        onClick={() => swStatus.applyUpdate()}
        data-testid="update-banner-refresh"
        style={{
          background: "var(--butter)",
          color: "var(--ink)",
          border: "none",
          borderRadius: "var(--r-sm)",
          padding: "6px 12px",
          fontSize: 13,
          fontWeight: 700,
          cursor: "pointer",
        }}
      >
        Oppdater
      </button>
    </div>
  );
}
